import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { api, sendAsync } from "../../app/applicationSlice"
import { RootState, RootThunk, RootThunkApi } from "../../app/store"
import {
  putstoragePage,
  putstorageDetail,
  putstorageSave,
  putstorageUpdata,
  putstorageSavelist,
  putstorageFinish,
  putlistDetail,
  putStorageparams,
  putStorePageParams,
  putstorageRect,
} from "../../services/putstorage"
import {
  GetDepartmentListParams,
  getDepartmentList,
} from "../../services/department"
import { Category } from "../../models/category"
import {
  setDurgData,
  setlistTotal,
  setSelectId,
} from "../putstorelist/putstorelistSlice"
import moment from "moment"
import { DateTimeFormatSimple } from "../../models/datetime"

const initialState = {
  PutstorageData: [],
  PutStorageUser: [],
  Total: 0,
  Detail: {},
  ID: 0,
  Success: false,
  department: [],
  Current: 1,
  Category: Category.GRRK,
}

export const putstorageSlice = createSlice({
  name: "putStorage",
  initialState,
  reducers: {
    setData(state, action) {
      state.PutstorageData = action.payload
    },
    setUser(state, action) {
      state.PutStorageUser = action.payload
    },
    setTotal(state, action) {
      state.Total = action.payload
    },
    setDetail(state, action) {
      state.Detail = action.payload
    },
    setId(state, action) {
      state.ID = action.payload
    },
    setSuccess(state, action) {
      state.Success = action.payload
    },
    setDepart(state, action) {
      state.department = action.payload
    },
    setCurrent(state, action) {
      state.Current = action.payload
    },
    setCategory(state, action) {
      state.Category = action.payload
    },
  },
})

export const {
  setData,
  setUser,
  setTotal,
  setDetail,
  setCategory,
  setId,
  setCurrent,
  setSuccess,
  setDepart,
} = putstorageSlice.actions

// 分页
export function pagePutstorage(params: putStorePageParams): RootThunk {
  return api(putstoragePage(params), (data: any, dispatch) => {
    dispatch(setData(data.records))
    dispatch(setTotal(data.total))
  })
}

export const pagePutstorageAsync = createAsyncThunk<
  void,
  putStorePageParams,
  RootThunkApi<void>
>("Putstorage/savelist", async (params, api) => {
  return sendAsync(putstoragePage(params), api, true)
})

//业务人员
export function pagePutstorageUser(params: putStorePageParams): RootThunk {
  return api(putstoragePage(params), (data: any, dispatch) => {
    dispatch(setUser(data.records))
  })
}

//部门
export function DepartmentDate(params: GetDepartmentListParams): RootThunk {
  return api(getDepartmentList(params), (data: any, dispatch) => {
    dispatch(setDepart(data.records))
  })
}

//详情
export function detailPutstorage(id: number): RootThunk {
  return api(putstorageDetail(id), (data: any, dispatch) => {
    dispatch(setDetail(data.inventoryReceipts))
    dispatch(
      setDurgData(
        data.outInvReceiptsItemList.map((v: any) => {
          return {
            ...v,
            deadline: v.deadline
              ? moment(v.deadline).format(DateTimeFormatSimple)
              : undefined,
            productDate: v.productDate
              ? moment(v.productDate).format(DateTimeFormatSimple)
              : undefined,
          }
        })
      )
    )
    dispatch(setlistTotal(data.outInvReceiptsItemList.total))
  })
}

// 新增
export function savePutstorage(params: putStorageparams): RootThunk {
  return api(putstorageSave(params), (data: any, dispatch) => {
    dispatch(setSelectId(data))
  })
}

// 修改
export function updataPutstorage(params: putStorageparams): RootThunk {
  return (dispatch, getState, args) => {
    api(putstorageUpdata(params), (data: any, dispatch) => {
      dispatch(detailPutstorage(params.id as number))
    })(dispatch, getState, args)
  }
}

//登账
export const savelistPutstorageAsync = createAsyncThunk<
  void,
  string,
  RootThunkApi<void>
>("Putstorage/savelist", async (id, api) => {
  return sendAsync(putstorageSavelist(id), api, true)
})

//冲正
export const rectPutstorageAsync = createAsyncThunk<
  void,
  string,
  RootThunkApi<void>
>("Putstorage/savelist", async (id, api) => {
  return sendAsync(putstorageRect(id), api, true)
})

//作废
export function finishPutstorage(id: number): RootThunk {
  return (dispatch, getState, args) => {
    const category = getState().putstorage.Category
    const current = getState().putstorage.Current
    api(putstorageFinish(id), (data) => {
      dispatch(pagePutstorage({ current, size: 10, category }))
    })(dispatch, getState, args)
  }
}

export const selectPutstorageData = (state: RootState) =>
  state.putstorage.PutstorageData

export const selectPutstorageUser = (state: RootState) =>
  state.putstorage.PutStorageUser

export const selectTotal = (state: RootState) => state.putstorage.Total

export const selectDetail = (state: RootState) => state.putstorage.Detail

export const selectId = (state: RootState) => state.putstorage.ID

export const selectDepartData = (state: RootState) =>
  state.putstorage.department

export const selectCurrent = (state: RootState) => state.putstorage.Current

export const selectCategory = (state: RootState) => state.putstorage.Category

export default putstorageSlice.reducer
